import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);




export default function SpiderChart({ data, massimo = 100, minimo = 0 }) {


  const options = {
    responsive: true,
    aspectRatio: false,
    maintainAspectRatio: false, // importante!
    layout: {
      padding: 0, // niente spazio interno
    },
    plugins: {
      legend: {
        display: false,
        position: 'bottom',
        align: 'center',
        labels: {
          boxWidth: 10,
          padding: 10,
          font: {
            size: 12,
            weight: 'bold',
          },
        },
      },
    },
    scales: {
      r: {
        min: minimo,
        max: massimo,
        ticks: {
          display: false,
        },
        pointLabels: {
          font: {
            size: 12,
            weight: 'bold',
          },
          padding: 10,
          callback: function (label) {
            return Array.isArray(label) ? label : [label]; // forza il rendering multilinea
          }
        },

        grid: {
          color: '#ccc',
          circular: false,
        },
        angleLines: {
          color: '#ccc',
        },
      },
    },
  };



  return (
    <div style={{ width: '100%', height: '100%', }} className='flex justify-center'>
      <Radar data={data} options={options} width={500} height={500} />
    </div>

  )

}